<div class="fixed-min-header-height pt-3 pt-md-4 pt-lg-0 grey-bg">
  <div class="container-fluid product-lisitng-wrapper cart-lisitng-wrapper">
    <div class="row">
      <div class="col-12">
        <a [routerLink]="['/mycart/']" title="back" class="back-listing-btn d-none d-lg-block back-cart" href="javascript:void(0);">
          <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Combined Shape</title>
            <desc>Created with Sketch.</desc>
            <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C"
                fill-rule="nonzero">
                <path
                  d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z"
                  id="Combined-Shape"></path>
              </g>
            </g>
          </svg> Back </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12 fixed-width-right-column">
          <!-- <div class="new-card-payment second">
              <div class="payment-box">
                <p (click)="paymentEvent()">Pay from saved cards</p>
                <div class="input-box">
                  <ul class="saved-card-listing" *ngIf='items != undefined && items.length != 0'>
                    <li *ngFor="let item of items; let i = index" [ngClass]="{'active': selectedItem === i}"
                      [value]="item.value" (click)='selectPaymentCard(i, item)'>
                      <p>
                        <span>
                          <img src="../../assets/images/{{item.image}}" alt="img">
                          
                        </span>
                        
                        {{item.value}}
                      </p>
                      <div class="delete-product">
                        <a href="javascript:void(0);" (click)="removeCard(item)" title="Delete product">
                            <img src="../../assets/images/delete.svg" alt="delete">
                        </a>
                    </div>
                     
                    </li>
                  </ul>
                  <div class="no-card-saved" *ngIf='items != undefined && items.length == 0'>
                    
                    <svg width="86" height="79" viewBox="0 0 86 79" xmlns="http://www.w3.org/2000/svg">
                      <g transform="translate(1 1)" fill-rule="nonzero" fill="none">
                          <path stroke="#000" stroke-width="2" fill="#099CE4" stroke-linecap="round" stroke-linejoin="round" d="M.148 16.501 73.889.531l9.758 45.054-73.742 15.97z"/>
                          <path fill="#D2DB2F" d="M3.146 25.635 74.98 10.077l1.776 8.201L4.922 33.836z"/>
                          <path stroke="#000" stroke-width="2" fill="#FFF" stroke-linecap="round" stroke-linejoin="round" d="M2.591 30.666h75.451v46.099H2.591z"/>
                          <rect fill="#D9394C" x="8.876" y="49.141" width="14.296" height="10.843" rx="3.453"/>
                          <path stroke="#000" stroke-width="2" fill="#7EAEFF" stroke-linecap="round" stroke-linejoin="round" d="M10.982 68.375h8.391M27.73 68.375h8.391M31.943 39.057h37.708M44.512 68.375h8.391M61.294 68.375h8.357"/>
                      </g>
                    </svg>
                    <h3>No saved cards</h3>
                    <p>You don’t have any saved cards yet!</p>
                  </div>
                </div>
              </div>
            </div> -->
        <!-- <form id="payment-form" method="POST" action="https://merchant.com/charge-card"> -->
        <div class="payment-container " >
          <div class="new-card-payment first">
            <div class="payment-box" >
              <!-- <p (click)="newpaymentEvent()">Pay with a new card</p> -->
              <p >Pay with a new card</p>
              <div class="input-box">
                <label>Enter Card Details</label>
                <div id="flow-container"></div>
                <!-- YOUR CUSTOM YELLOW ANGULAR PAY BUTTON -->
                <div class="custom-angular-action-block" *ngIf="isFormRendered">
                  <button id="custom-pay-now-btn"
                          type="button"
                          class="newcard-payment"
                          [disabled]="isPaymentLoading"
                          (click)="$event.preventDefault(); submitPayment()">
                    
                    <span *ngIf="!isPaymentLoading">
                      PAY £ {{orderDetail?.cart_total?.grand_total}}
                    </span>
                
                    <span *ngIf="isPaymentLoading">
                      Processing...
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <button id="savecardpay-button" *ngIf='orderDetail != null' class='savecard-payment' disabled (click)="paymentUsingSaveCard(errorTemplate, infoTemplate)">
          PAY £ {{orderDetail?.cart_total?.grand_total}}
        </button> -->
        <!-- <button id="submit-savecard" (click)="test(errorTemplate, infoTemplate)">
          test
        </button> -->
        <input id='card-token' value=''>
        <input id='card-bin' value=''>
      </div>
      
      <div class="col-12 fixed-width-left-column" *ngIf='orderDetail != null'>
        <div class="quick-add-box order-details">
          <h3>Order Summary</h3>
          <div class="product-detail">
            <ul>
              <li>
                <p *ngIf="orderDetail.items_count == '1'">Item</p>
                <p *ngIf="orderDetail.items_count != '1'">Items</p>
                <span>{{orderDetail.items_count}}</span>
              </li>
              <li>
                <p *ngIf="orderDetail.items_qty == '1'">Case</p>
                <p *ngIf="orderDetail.items_qty != '1'">Cases</p>
                <span>{{orderDetail.items_qty}}</span>
              </li>
              <li>
                <p>Net Amount:</p><span>£{{orderDetail?.cart_total?.subtotal}}</span>
              </li>
            </ul>
          </div>
          <div class="promotion-listing" *ngIf='orderDetail?.promotions?.length != 0'>
            <h5>
              Promotion:
            </h5>
            <ul>
              <li  *ngFor="let pro of orderDetail.promotions">
                <p>{{pro.name}}</p><span class="red">- £{{pro.discount}}</span>
              </li>
            </ul>
          </div>
          <div class="promotion-listing discount" *ngIf="(orderDetail?.cart_total.store_discount != '' && orderDetail.cart_total.store_discount >  0)">
            <h5>
              Discount Applied:
            </h5>
            <span class="red">- £{{orderDetail['cart_total']?.store_discount}}</span>
          </div>
          <div class="promotion-listing discount" *ngIf="global_data?.price_visibility == 1 && global_data?.vat_exempt == 0">
            <h5>
              VAT:
            </h5>
            <span>£{{orderDetail.cart_total.vat}}</span>
          </div>
          <div class="promotion-listing discount total">
            <h5>
              Total Amount:
            </h5>
            <span>£{{orderDetail?.cart_total?.grand_total}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #errorTemplate>
  <div class="modal-header border-0 pb-2 align-items-center">
      <h4 class="modal-title">Error</h4>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p>{{errorMessage}} </p>
        </div>
        <div class="button-div text-center mt-3 align-items-center">
          <button class="common-button mr-3 error-btn" (click)="closeErrorPopup()">Try Again</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #infoTemplate>
  <div class="modal-header border-0 pb-2 align-items-center">
      <h4 class="modal-title">Info</h4>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p>We are redirecting you to the payment gateway screen, do not refresh or close the window till the order gets complete.Also, please make sure that new pop window is enabled for your browser to complete the order.</p>
        </div>
        <div class="button-div text-center mt-3 align-items-center">
          <button class="common-button mr-3 error-btn" (click)="closeInfoPopup()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>